<template>
    <div class="page-header">
        <div class="row align-items-center">
            <div class="col">
                <h3 class="page-title">{{title}}</h3>
                <ul class="breadcrumb">
                    <li class="breadcrumb-item">
                        <!-- <router-link to="/dashboard">{{path}}</router-link> -->
                         {{ path }}
                    </li>
                    <!-- <li class="breadcrumb-item"><router-link to="/employee/employees">{{text}}</router-link></li> -->
                    <li class="breadcrumb-item active">{{text1}}</li>
                </ul>
            </div>
            <div class="col-auto float-end ms-auto">
                <a href="javascript:;" class="btn add-btn" data-bs-toggle="modal" data-bs-target="#add_manual_activity">
                    <i class="fa-solid fa-plus"></i> Add Activity
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: "",
        },
        path: {
            type: String,
            default: "",
        },
        text: {
            type: String,
            default: "",
        },
        text1: {
            type: String,
            default: "",
        },
        text2: {
            type: String,
            default: "",
        },
        text3: {
            type: String,
            default: "",
        }
    },
    // computed: {
    //     isShiftSchedulingRoute() {
    //         return this.$route.path === "/shift-scheduling";
    //     },
    //     isShiftListRoute() {
    //         return this.$route.path === "/shift-list";
    //     },
    // },
}
</script>